import React from 'react';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button, Link } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';

import { useStyles } from './styles';
import useFormula from '../../hooks/Formula';

const renderTypeSelect = ({ field }) => <Select {...field} options={[{ value: 'USER_BONUS', label: 'User Bonus' }]} />;

export default function FormulaList() {
  const { control, handleSubmit } = useForm();
  const navigate = useNavigate();
  const onSubmit = (data) => {
    // console.log(data)
  };

  const { classes } = useStyles();
  const { formulas, type, setType } = useFormula();

  const viewInDetail = (id) => {
    navigate(`/formulas/${id}`);
  };
  return (
    <div>
      <Box sx={{ mt: 3 }}>
        <Grid container spacing={3}>
          <Grid size={6}>
            <Box>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Controller name="type" control={control} render={renderTypeSelect} />
              </form>
            </Box>
          </Grid>
          <Grid size={6}>
            <Button component={Link} href="/formulas/create" variant="contained" color="primary">
              Create
            </Button>
          </Grid>
        </Grid>
      </Box>
      {formulas && (
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>Formula</TableCell>
                <TableCell>Order</TableCell>
                <TableCell>regions</TableCell>
                <TableCell>Subjects</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formulas &&
                formulas.length > 0 &&
                formulas.map((item) => (
                  <TableRow
                    hover
                    key={item.id}
                    className={classes.tableRow}
                    onClick={() => {
                      viewInDetail(item.id);
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {item.type}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item.formula}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item.order}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item.regions}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      {item.regions && item.subjects.length > 0 ? item.subjects.join(', ') : ''}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
}
